module.exports = __webpack_public_path__ + "media/theme/blog__ico-check-1-0575b143.png";